import { render, staticRenderFns } from "./MessageControls.vue?vue&type=template&id=8a9a3e22&scoped=true"
import script from "./MessageControls.vue?vue&type=script&lang=js"
export * from "./MessageControls.vue?vue&type=script&lang=js"
import style0 from "./MessageControls.vue?vue&type=style&index=0&id=8a9a3e22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9a3e22",
  null
  
)

export default component.exports